import { Dispatch } from "redux";

import { SettingsOfficeStateAction } from "@reducers/types/HRM/settings/settings-office-state";

import {
  GET_HRM_SETTINGS_OFFICE,
  GET_SINGLE_HRM_SETTINGS_OFFICE,
  CREATE_HRM_SETTINGS_OFFICE,
  UPDATE_HRM_SETTINGS_OFFICE,
  DELETE_HRM_SETTINGS_OFFICE,
} from "./types";

import { SettingsOfficeCreateType } from "@type/HRM/settings/settings-office";

import {
  fetchSettingsOffice,
  fetchSettingsOfficeById,
  createSettingsOffice,
  updateSettingsOffice,
  deleteSettingsOffice,
} from "@api/hrm-settings";

export const settingsOfficeFetchActionHandler =
  (query: any) => async (dispatch: Dispatch<SettingsOfficeStateAction>) => {
    dispatch({ type: GET_HRM_SETTINGS_OFFICE.LOADING, payload: true });

    try {
      const res = await fetchSettingsOffice(query);

      const { data, page, size, total } = res.data || {};

      dispatch({
        type: GET_HRM_SETTINGS_OFFICE.SUCCESS,
        payload: {
          data: data,
          pagination: {
            page: page || 0,
            size: size || 0,
            total: total || 0,
          },
        },
      });
    } catch (err) {
      dispatch({ type: GET_HRM_SETTINGS_OFFICE.ERROR, payload: err });
    }
  };

export const settingsOfficeByIdFetchActionHandler =
  (id: string | number) =>
  async (dispatch: Dispatch<SettingsOfficeStateAction>) => {
    dispatch({ type: GET_SINGLE_HRM_SETTINGS_OFFICE.LOADING, payload: true });

    try {
      const res = await fetchSettingsOfficeById(id);

      dispatch({
        type: GET_SINGLE_HRM_SETTINGS_OFFICE.SUCCESS,
        payload: res.data || {},
      });
    } catch (err) {
      dispatch({ type: GET_SINGLE_HRM_SETTINGS_OFFICE.ERROR, payload: err });
    }
  };

export const settingsOfficeCreateActionHandler =
  (data: SettingsOfficeCreateType) =>
  async (dispatch: Dispatch<SettingsOfficeStateAction>) => {
    dispatch({ type: CREATE_HRM_SETTINGS_OFFICE.LOADING, payload: true });

    try {
      const res = await createSettingsOffice(data);

      dispatch({ type: CREATE_HRM_SETTINGS_OFFICE.SUCCESS, payload: res.data });
    } catch (err) {
      dispatch({ type: CREATE_HRM_SETTINGS_OFFICE.ERROR, payload: err });
    }
  };

export const settingsOfficeUpdateActionHandler =
  (id: string | number, data: SettingsOfficeCreateType) =>
  async (dispatch: Dispatch<SettingsOfficeStateAction>) => {
    dispatch({ type: UPDATE_HRM_SETTINGS_OFFICE.LOADING, payload: true });

    try {
      const res = await updateSettingsOffice(id, data);

      dispatch({
        type: UPDATE_HRM_SETTINGS_OFFICE.SUCCESS,
        payload: res.data,
      });
    } catch (err) {
      dispatch({ type: UPDATE_HRM_SETTINGS_OFFICE.ERROR, payload: err });
    }
  };

export const settingsOfficeDeleteActionHandler =
  (id: string | number) =>
  async (dispatch: Dispatch<SettingsOfficeStateAction>) => {
    dispatch({ type: DELETE_HRM_SETTINGS_OFFICE.LOADING, payload: true });

    try {
      const res = await deleteSettingsOffice(id);

      dispatch({ type: DELETE_HRM_SETTINGS_OFFICE.SUCCESS, payload: res.data });
    } catch (err) {
      dispatch({ type: DELETE_HRM_SETTINGS_OFFICE.ERROR, payload: err });
    }
  };
